<template>
  <div class="p-4 text-center mt-2 lg:mt-8 lg:mb-8">
    <div class="lg:flex">
      <h1 class="w-full lg:w-8 flex align-items-center justify-content-center text-2xl lg:text-3xl lg:pr-6 lg:pl-2 pb-6 lg:pb-0 font-normal">
        Ciao! Mi chiamo Giosuè Addario. Sono un Full-Stack Developer. <br />Ho
        la passione per informatica, Scienza, Storia, Libri, Cinema, Serie TV e
        Videogiochi.
      </h1>
      <div class="w-full lg:w-4 lg:mt-0">
        <div
          class="profilo select-none fadeinleft animation-duration-500 animation-iteration-1"
        ></div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
export default {
  name: "Descrizione",
  data() {
    return {};
  },
  computed: {
    ...mapGetters({}),
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only 
-->
<style scoped lang="scss">
.profilo {
  text-align: center;
  border-radius: 50%;
  height: 300px;
  width: 300px;
  background-image: url("../assets/profilo.png");
  background-size: cover;
  background-repeat: no-repeat;
  //  background-attachment: fixed;
  //background-size:auto 60vh;
  background-position: center;
  margin-left: auto;
  margin-right: auto;
  margin-bottom: 1.5rem !important;
}
</style>
